import { render, staticRenderFns } from "./warehouseTable.vue?vue&type=template&id=02c28f03&"
import script from "./warehouseTable.vue?vue&type=script&lang=js&"
export * from "./warehouseTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports